import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { mirronPageMeta, mirronSchema } from 'components/common/schema'
import Template from 'components/cases/mirron'

const Mirron: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...mirronPageMeta} />
      <JsonLd data={mirronSchema} />
      <Template />
    </>
  )
}

export default Mirron
